import { Text } from 'blaze-ui/Text/Text'
import Styles from './AutopilotProPill.module.scss'
import { useOpenAutopilotUpgrade } from 'hooks/useOpenAutopilotUpgrade'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import LockOpen3 from 'blaze-ui/icons/24/LockOpen3'

export const WithAutopilotProPill = ({
  children,
}: {
  children: React.ReactNode | ((args: { isRenderingPill: boolean }) => React.ReactNode)
}): React.ReactElement => {
  const workspace = useCurrentWorkspace()
  const isPillVisible = Boolean(workspace?.is_ap_freemium)

  const content =
    typeof children === 'function'
      ? (children as (args: { isRenderingPill: boolean }) => React.ReactNode)({ isRenderingPill: isPillVisible })
      : children

  if (isPillVisible) {
    return (
      <div className={Styles.container}>
        {content}
        <AutopilotProPill />
      </div>
    )
  }

  return <>{content}</>
}

export const AutopilotProPill = () => {
  const openVirtualMarketerPlansModal = useOpenAutopilotUpgrade()

  return (
    <button
      className={Styles.pill}
      onClick={(e) => {
        e.preventDefault()
        openVirtualMarketerPlansModal()
      }}
    >
      <LockOpen3 size={12} color="#9500FF" />
      <Text variant="label" color="#9500FF">
        Upgrade
      </Text>
    </button>
  )
}
